/**
 * Generated from LightsOutElmoBedroomLayout.fla
 */
export function LightsOutElmoBedroomLayout(this: ILightsOutElmoBedroomLayout) {
	const bg = this.bg;
	LightsOutElmoBedroomLayout_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	if (bg.onLayout) bg.onLayout();
	const rocket = this.rocket;
	LightsOutElmoBedroomLayout_rocket.call(this.rocket);
	rocket.x = 830;
	rocket.y = 0;
	rocket.width = 128.00;
	rocket.height = 316.00;
	if (rocket.onLayout) rocket.onLayout();
	const radio = this.radio;
	LightsOutElmoBedroomLayout_radio.call(this.radio);
	radio.x = 927.75;
	radio.y = 583.75;
	radio.width = 84.50;
	radio.height = 60.50;
	if (radio.onLayout) radio.onLayout();
	const lightswitch = this.lightswitch;
	LightsOutElmoBedroomLayout_lightswitch.call(this.lightswitch);
	lightswitch.x = 1181.75;
	lightswitch.y = 371.25;
	lightswitch.width = 23.50;
	lightswitch.height = 38.50;
	if (lightswitch.onLayout) lightswitch.onLayout();
	const toybear = this.toybear;
	LightsOutElmoBedroomLayout_toybear.call(this.toybear);
	toybear.x = 542.25;
	toybear.y = 224.25;
	toybear.width = 66.50;
	toybear.height = 77.50;
	if (toybear.onLayout) toybear.onLayout();
	const car = this.car;
	LightsOutElmoBedroomLayout_car.call(this.car);
	car.x = 575.25;
	car.y = 502.5;
	car.width = 76.50;
	car.height = 43.00;
	if (car.onLayout) car.onLayout();
	const laptop = this.laptop;
	LightsOutElmoBedroomLayout_laptop.call(this.laptop);
	laptop.x = 675.5;
	laptop.y = 493.75;
	laptop.width = 102.00;
	laptop.height = 60.50;
	if (laptop.onLayout) laptop.onLayout();
	const helicopter = this.helicopter;
	LightsOutElmoBedroomLayout_helicopter.call(this.helicopter);
	helicopter.x = 713.25;
	helicopter.y = 621.5;
	helicopter.width = 64.50;
	helicopter.height = 62.00;
	if (helicopter.onLayout) helicopter.onLayout();
	const lamp = this.lamp;
	LightsOutElmoBedroomLayout_lamp.call(this.lamp);
	lamp.x = 404.25;
	lamp.y = 445;
	lamp.width = 69.50;
	lamp.height = 99.50;
	if (lamp.onLayout) lamp.onLayout();
	const ceilinglamp = this.ceilinglamp;
	LightsOutElmoBedroomLayout_ceilinglamp.call(this.ceilinglamp);
	ceilinglamp.x = 1070.5;
	ceilinglamp.y = 0;
	ceilinglamp.width = 106.00;
	ceilinglamp.height = 146.00;
	if (ceilinglamp.onLayout) ceilinglamp.onLayout();
	const dinosaur = this.dinosaur;
	LightsOutElmoBedroomLayout_dinosaur.call(this.dinosaur);
	dinosaur.x = 849.5;
	dinosaur.y = 411;
	dinosaur.width = 66.00;
	dinosaur.height = 68.00;
	if (dinosaur.onLayout) dinosaur.onLayout();
	const ceilinglampGlow = this.ceilinglampGlow;
	LightsOutElmoBedroomLayout_ceilinglampGlow.call(this.ceilinglampGlow);
	ceilinglampGlow.x = 1070.5;
	ceilinglampGlow.y = 136.25;
	ceilinglampGlow.width = 127.00;
	ceilinglampGlow.height = 41.50;
	if (ceilinglampGlow.onLayout) ceilinglampGlow.onLayout();
	const lampGlow = this.lampGlow;
	LightsOutElmoBedroomLayout_lampGlow.call(this.lampGlow);
	lampGlow.x = 403.95;
	lampGlow.y = 373.5;
	lampGlow.width = 86.50;
	lampGlow.height = 66.00;
	if (lampGlow.onLayout) lampGlow.onLayout();
	const homeButton = this.homeButton;
	LightsOutElmoBedroomLayout_homeButton.call(this.homeButton);
	homeButton.x = 428;
	homeButton.y = 164.5;
	homeButton.width = 146.00;
	homeButton.height = 151.00;
	if (homeButton.onLayout) homeButton.onLayout();
	const elmo = this.elmo;
	LightsOutElmoBedroomLayout_elmo.call(this.elmo);
	elmo.x = 1156;
	elmo.y = 731.25;
	elmo.width = 176.80;
	elmo.height = 256.00;
	if (elmo.onLayout) elmo.onLayout();
	return this;
}
function LightsOutElmoBedroomLayout_bg(this: ILightsOutElmoBedroomLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("lightsout-bedroom-background.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBedroomLayout_rocket(this: ILightsOutElmoBedroomLayout_rocket) {
	if (this.setLayoutTexture) this.setLayoutTexture("rocket.png", 0.500, 0.000);
	return this;
}
function LightsOutElmoBedroomLayout_radio(this: ILightsOutElmoBedroomLayout_radio) {
	if (this.setLayoutTexture) this.setLayoutTexture("radio.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBedroomLayout_lightswitch(this: ILightsOutElmoBedroomLayout_lightswitch) {
	if (this.setLayoutTexture) this.setLayoutTexture("lightswitch.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBedroomLayout_toybear(this: ILightsOutElmoBedroomLayout_toybear) {
	if (this.setLayoutTexture) this.setLayoutTexture("toybear.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBedroomLayout_car(this: ILightsOutElmoBedroomLayout_car) {
	if (this.setLayoutTexture) this.setLayoutTexture("car.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBedroomLayout_laptop(this: ILightsOutElmoBedroomLayout_laptop) {
	if (this.setLayoutTexture) this.setLayoutTexture("laptop.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBedroomLayout_helicopter(this: ILightsOutElmoBedroomLayout_helicopter) {
	if (this.setLayoutTexture) this.setLayoutTexture("helicopter.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBedroomLayout_lamp(this: ILightsOutElmoBedroomLayout_lamp) {
	if (this.setLayoutTexture) this.setLayoutTexture("lamp.png", 0.504, 1.000);
	return this;
}
function LightsOutElmoBedroomLayout_ceilinglamp(this: ILightsOutElmoBedroomLayout_ceilinglamp) {
	if (this.setLayoutTexture) this.setLayoutTexture("ceilinglight.png", 0.500, 0.000);
	return this;
}
function LightsOutElmoBedroomLayout_dinosaur(this: ILightsOutElmoBedroomLayout_dinosaur) {
	if (this.setLayoutTexture) this.setLayoutTexture("dinosaur.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBedroomLayout_ceilinglampGlow(this: ILightsOutElmoBedroomLayout_ceilinglampGlow) {
	if (this.setLayoutTexture) this.setLayoutTexture("ceilinglight-on-glow.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBedroomLayout_lampGlow(this: ILightsOutElmoBedroomLayout_lampGlow) {
	if (this.setLayoutTexture) this.setLayoutTexture("lamp-on-glow.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBedroomLayout_homeButton(this: ILightsOutElmoBedroomLayout_homeButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("home-btn.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBedroomLayout_elmo(this: ILightsOutElmoBedroomLayout_elmo) {
	if (this.setLayoutTexture) this.setLayoutTexture("Elmo.png", 0.549, 1.000);
	return this;
}
interface ILightsOutElmoBedroomLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ILightsOutElmoBedroomLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ILightsOutElmoBedroomLayoutSprite extends ILightsOutElmoBedroomLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ILightsOutElmoBedroomLayoutText extends ILightsOutElmoBedroomLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ILightsOutElmoBedroomLayoutPolygon extends Array<number> {
}
interface ILightsOutElmoBedroomLayout {
	readonly bg: ILightsOutElmoBedroomLayout_bg;
	readonly rocket: ILightsOutElmoBedroomLayout_rocket;
	readonly radio: ILightsOutElmoBedroomLayout_radio;
	readonly lightswitch: ILightsOutElmoBedroomLayout_lightswitch;
	readonly toybear: ILightsOutElmoBedroomLayout_toybear;
	readonly car: ILightsOutElmoBedroomLayout_car;
	readonly laptop: ILightsOutElmoBedroomLayout_laptop;
	readonly helicopter: ILightsOutElmoBedroomLayout_helicopter;
	readonly lamp: ILightsOutElmoBedroomLayout_lamp;
	readonly ceilinglamp: ILightsOutElmoBedroomLayout_ceilinglamp;
	readonly dinosaur: ILightsOutElmoBedroomLayout_dinosaur;
	readonly ceilinglampGlow: ILightsOutElmoBedroomLayout_ceilinglampGlow;
	readonly lampGlow: ILightsOutElmoBedroomLayout_lampGlow;
	readonly homeButton: ILightsOutElmoBedroomLayout_homeButton;
	readonly elmo: ILightsOutElmoBedroomLayout_elmo;
}
interface ILightsOutElmoBedroomLayout_bg extends ILightsOutElmoBedroomLayoutSprite {
}
interface ILightsOutElmoBedroomLayout_rocket extends ILightsOutElmoBedroomLayoutSprite {
}
interface ILightsOutElmoBedroomLayout_radio extends ILightsOutElmoBedroomLayoutSprite {
}
interface ILightsOutElmoBedroomLayout_lightswitch extends ILightsOutElmoBedroomLayoutSprite {
}
interface ILightsOutElmoBedroomLayout_toybear extends ILightsOutElmoBedroomLayoutSprite {
}
interface ILightsOutElmoBedroomLayout_car extends ILightsOutElmoBedroomLayoutSprite {
}
interface ILightsOutElmoBedroomLayout_laptop extends ILightsOutElmoBedroomLayoutSprite {
}
interface ILightsOutElmoBedroomLayout_helicopter extends ILightsOutElmoBedroomLayoutSprite {
}
interface ILightsOutElmoBedroomLayout_lamp extends ILightsOutElmoBedroomLayoutSprite {
}
interface ILightsOutElmoBedroomLayout_ceilinglamp extends ILightsOutElmoBedroomLayoutSprite {
}
interface ILightsOutElmoBedroomLayout_dinosaur extends ILightsOutElmoBedroomLayoutSprite {
}
interface ILightsOutElmoBedroomLayout_ceilinglampGlow extends ILightsOutElmoBedroomLayoutSprite {
}
interface ILightsOutElmoBedroomLayout_lampGlow extends ILightsOutElmoBedroomLayoutSprite {
}
interface ILightsOutElmoBedroomLayout_homeButton extends ILightsOutElmoBedroomLayoutSprite {
}
interface ILightsOutElmoBedroomLayout_elmo extends ILightsOutElmoBedroomLayoutSprite {
}
